export const rootPath = '/';
export const beetGrowingPath = '/beet-growing';
export const toolsPath = '/tools';
export const termsPath = '/terms-condition';
export const dataProtectionPath = '/data-protection';
export const imprintPath = '/imprint';
export const unauthenticatedHomePath = '/unauthenticated-home';
export const campaignsPath = `${beetGrowingPath}/campaigns`;
export const myContractsPath = `/my-contracts`;
export const singleBeetDeliveryPath = `${beetGrowingPath}/single-beet-delivery`;
export const financesPath = `${beetGrowingPath}/finances`;
export const orderedDeliveredProductsPath = `/ordered-delivered-products`;
export const loginPath = '/login';
export const logoutPath = '/logout';
export const myCampaignPath = `/my-campaign`;
export const myPaymentsPath = `/my-payments`;
export const myFieldsYieldsPath = `/my-fields-yields`;
export const userSettingsPath = `/settings`;
export const masterdataPath = `/masterdata`;
export const myContactsPath = `/my-contacts`;
export const administrationPath = `/admin`;
export const loggedOutPath = '/loggedout';
export const translationsAdminPath = '/admin/translations';
export const statisticAdminPath = '/admin/statistic';
export const surveyPath = `/survey`;
export const contactsAdminPath = '/admin/contacts';
export const fieldNominationPath = `/field-nomination/cropSeasons`;
export const eContractingPath = `/e-contracting`;
export const devPlaygroundPath = `/dev`;
export const myTasksAdminPath = '/admin/my-tasks';
export const redCertPath = `/red-cert`;
export const individualDocumentsPath = '/individual-documents';
export const individualDocumentsAllPath = '/individual-documents?folder=all';
export const individualDocumentsNewslettersPath =
  '/individual-documents?folder=newsletters';
export const individualDocumentsLiefermitteilungenPath =
  '/individual-documents?folder=liefermitteilungen';
export const individualDocumentsAnbauempfehlungPath =
  '/individual-documents?folder=anbauempfehlung';
export const notFoundPath = '*';

export const getPageName = (path: string) => {
  switch (path) {
    case rootPath:
      return 'Home';
    case beetGrowingPath:
      return 'Beet Growing';
    case toolsPath:
      return 'Tools';
    case termsPath:
      return 'Terms & Conditions';
    case dataProtectionPath:
      return 'Data Protection';
    case imprintPath:
      return 'Imprint';
    case unauthenticatedHomePath:
      return 'Unauthenticated Home';
    case campaignsPath:
      return 'Campaigns';
    case myContractsPath:
      return 'Contracts';
    case singleBeetDeliveryPath:
      return 'Single Beet Delivery';
    case financesPath:
      return 'Finances';
    case orderedDeliveredProductsPath:
      return 'Ordered & Delivered Products';
    case logoutPath:
      return 'Logout';
    case myCampaignPath:
      return 'My Campaign';
    case myPaymentsPath:
      return 'My Payments';
    case myFieldsYieldsPath:
      return 'My Fields & Yields';
    case userSettingsPath:
      return 'Settings';
    case myContactsPath:
      return 'My Contacts';
    case masterdataPath:
      return 'Masterdata';
    case administrationPath:
      return 'Administration Page';
    case loggedOutPath:
      return 'Logged Out';
    case translationsAdminPath:
      return 'Translations Administration';
    case statisticAdminPath:
      return 'Statistic Administration';
    case surveyPath:
      return 'Survey';
    case contactsAdminPath:
      return 'Contacts editing';
    case fieldNominationPath:
      return 'Field Nomination';
    case devPlaygroundPath:
      return 'Dev playground';
    case eContractingPath:
      return 'E-Contracting';
    case myTasksAdminPath:
      return 'My Tasks Administration';
    case redCertPath:
      return 'Red Cert';
    case individualDocumentsPath:
      return 'Individual Documents';
    default:
      return 'Page Not Found';
  }
};
